import { Injectable } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Injectable({
  providedIn: 'root'
})
export class FullscreenDialogService{

  constructor() { }

  currentFullScreenDialog;

  saveDialog<T> (dialogRef: MatDialogRef<T>) {
    this.closeDialog();
    this.scrollTop();
    this.currentFullScreenDialog = dialogRef;
  }

  scrollTop() {
    document.getElementsByClassName('mat-drawer-content')[0].scrollTop = 0;
  }

  closeDialog() {
    if (this.currentFullScreenDialog) {
      this.currentFullScreenDialog.close();
    }
  }
}
